"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.common.yes': 'Sí',
    'profession.common.no': 'No',
};
